export default "__VITE_ASSET__DSTTexgF__"